import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { Partner, partnersService, UpdatePartnerRequest } from '@aslanpay/portal-common-lib';

const useUpdatePartner = ({
  onSuccess,
  onError,
}: UseMutationOptions<Partner, Error, UpdatePartnerRequest>) => {
  return useMutation<Partner, Error, UpdatePartnerRequest>(
    (request: UpdatePartnerRequest) => partnersService.updatePartner(request),
    { onSuccess, onError }
  );
};

export default useUpdatePartner;
